<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Purchase'
};
</script>

<style lang="less" scoped></style>
